import React from "react"
import Paper from "material-ui/Paper"
import FlatButton from "material-ui/FlatButton"
import BiometricExceptionInfo from "./BiometricExceptionInfo"
import BiometricExceptionConfirmedImages from "./BiometricExceptionConfirmedImages"
import strings from "../../../../localization/strings"
import ExceptionStore from "../../../../stores/ExceptionStore"
import AuthenticationStore from "../../../../stores/AuthenticationStore"
import autobind from "class-autobind"
import * as exceptionActions from "../../../../actions/ExceptionActions"
import * as permissionHelper from "../../../../helpers/permissionHelper"
import { IPunchException, IBiometricException, EExceptionType } from "../../../../models"
import BioExceptionDayRecordTable from "./BioExceptionDayRecordTable"
import _ from "lodash"
import * as punchActions from "../../../../actions/PunchActions"
import AppStateStore from "../../../../stores/AppStateStore"

interface IProps {
    punchId: string
    paperHeight: number
}
interface IState {
    reviewing: boolean
    biometricException: IPunchException
    exceptionRecord: IBiometricException
}

export default class BiometricException extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            reviewing: false,
            biometricException: null,
            exceptionRecord: null
        }
        autobind(this)
        exceptionActions.loadBiometricExceptionDetails(this.props.punchId)
    }

    componentWillReceiveProps(nextProps: IProps) {
        this.props.punchId !== nextProps.punchId &&
            exceptionActions.loadBiometricExceptionDetails(nextProps.punchId)
    }

    componentDidMount() {
        ExceptionStore.on("change", this.changeEvent)
    }

    componentWillUnmount() {
        ExceptionStore.removeListener("change", this.changeEvent)
    }

    changeEvent() {
        const exceptionRecord = ExceptionStore.getBiometricException()
        const biometricException = exceptionRecord.Record.Punch.PunchExceptions.find(i => i.TypeEnum === EExceptionType.BIOMETRIC)
        this.setState({
            exceptionRecord,
            biometricException,
            reviewing: false
        })
    }

    handleReview(type: "accept" | "reject" | "reject_remove") {
        this.setState({ reviewing: true }, () => {
            const biometricException = _.cloneDeep(this.state.biometricException)
            if (type === "accept") {
                biometricException.Approved = true
            }
            if (type === "reject" || type === "reject_remove") {
                biometricException.Rejected = true
            }
            biometricException.Reviewed = true
            exceptionActions.reviewBioException(this.props.punchId, biometricException, () => {
                type === "reject_remove" ?
                    punchActions.deletePunch(null, this.props.punchId, false,
                        () => {
                            exceptionActions.loadBiometricExceptionDetails(this.props.punchId)
                            AppStateStore.setProgressSnackbarContent(null)
                        }
                    ) :
                    exceptionActions.loadBiometricExceptionDetails(this.props.punchId)
            })
        })
    }

    render() {
        return (
            <div className="biometric-exception" style={{ justifyContent: "center" }}>
                {this.state.biometricException &&
                    <div>
                        {!this.state.biometricException.Approved && !this.state.biometricException.Rejected &&
                            permissionHelper.hasPermission(AuthenticationStore.Permissions.PunchRecords.EditExceptions) &&
                            <div style={{ position: "absolute", right: 30, top: -45 }}>
                                <FlatButton
                                    data-intercom-target={`ExceptionDialog-BiometricException-${this.props.punchId}-Btn-AcceptException`}
                                    label={strings.ACCEPT}
                                    primary
                                    style={{ float: "right" }}
                                    icon={<i className="fa fa-check" />}
                                    disabled={this.state.reviewing}
                                    onClick={() => this.handleReview("accept")}
                                />
                                <FlatButton
                                    data-intercom-target={`ExceptionDialog-BiometricException-${this.props.punchId}-Btn-RejectException`}
                                    label={strings.REJECT}
                                    secondary
                                    style={{ float: "right" }}
                                    icon={<i className="fa fa-remove" />}
                                    disabled={this.state.reviewing}
                                    onClick={() => this.handleReview("reject")}
                                />
                                <FlatButton
                                    data-intercom-target={`ExceptionDialog-BiometricException-${this.props.punchId}-Btn-RejectDeleteException`}
                                    label={strings.REJECT_REMOVE}
                                    secondary
                                    style={{ float: "right" }}
                                    icon={<i className="fa fa-trash" />}
                                    disabled={this.state.reviewing}
                                    onClick={() => this.handleReview("reject_remove")} />
                                <div style={{ clear: "both" }} />
                            </div>
                        }
                        <Paper style={{ overflowY: "auto", height: this.props.paperHeight, marginLeft: 45, marginTop: 45, width: 1060 }}>
                            <BiometricExceptionInfo
                                exception={this.state.biometricException}
                                biometricException={this.state.exceptionRecord}
                            />
                            <BiometricExceptionConfirmedImages bioExceptionRecord={this.state.exceptionRecord} />
                            {!this.state.biometricException.Approved && !this.state.biometricException.Rejected &&
                                <BioExceptionDayRecordTable
                                    record={this.state.exceptionRecord.Record}
                                />
                            }
                        </Paper>
                    </div>
                }
            </div>
        )
    }
}
